angular.module('aol.service', ['ngResource']);